<template>
  <div class="identity-list">
    <div class="title-c">请选择身份</div>
    <div class="identity-item" :class="{ active: selectIndex === 'parent' }">
      <img src="@/assets/user-parent.png" alt="" @click="select('parent')" />
    </div>
    <div class="identity-item" :class="{ active: selectIndex === 'teacher' }">
      <img src="@/assets/user-teacher.png" alt="" @click="select('teacher')" />
    </div>
    <!-- <div class="identity-item" :class="{ active: selectIndex === 'kaoguan' }">
      <img src="@/assets/user-kaoguan.png" alt="" @click="select('kaoguan')" />
    </div> -->
     <CustomButton  text="下一步" @click="onSubmit" :disabled="!filterSubmit" type='1'/>
    <!-- <van-button
      :disabled="!filterSubmit"
      round
      block
      type="primary"
      @click="onSubmit"
    >
      下一步
    </van-button> -->
  </div>
</template>

<script >
  import { setStorage ,getLocal,setLocal,getSession} from "@/utils/cookie";
import { getOpenId,loginByOpenId ,checkPersonType} from "@/api/bind";
import { getCode } from "@/utils/wx.js";
  import CustomButton from "@/components/CustomButton.vue";
  
export default {
  name: 'index',
  components: {
    CustomButton
  },
  props: {
  },
  data() {
    return {
      showTypePicker: false,
      selectIndex:''
    }
  },
  created() {

  },
  computed:{
    filterSubmit(){
  return Boolean(this.selectIndex);
}
  },
mounted(){
  this.init()
},
  methods: {
init(){
 // 检测人员身份
 
   checkPersonType({openId:getLocal('openId')}).then(res=>{
    // -1:未绑定 -2：全部绑定 1：老师 8：家长
              console.log(res.data.body);
              if (+res.data.body==-2) {
                this.$router.push(`/personalInfo`);
              }

              })

  loginByOpenId({openId:getLocal('openId')}).then(res=>{
              console.log(res);
              if (res.data.obj=="personBindErrorCode") {
                
              }else{
    setLocal("userInfo", JSON.stringify(res.data.body));
    setLocal("Authorization", res.data.body.token);
              }


    // this.$router.push(`/personalInfo`);
              }).catch((error) => {
              const response = error.response
              console.log(response);
              // if(response.data.status=="-6017"){
              //   // 未绑定
              
              //   next({
              //     path: "/index",
              //     query: {
              //       backUrl: to.path,
              //     },
              //   });
              // }else {
              //   next({
              //     path: "/500",
              //     query: {
              //       message: e.message,
              //     },
              //   });
              // }
            })
},
 select(index) {
    this.selectIndex = index;
  },

   onSubmit() {
    const identity = this.selectIndex;
    setStorage("identity", identity);
    if (this.selectIndex=='parent') {
    this.$router.push(`/parentReg?identity=${identity}&backUrl=${this.$route.query.backUrl}`);
    }else if(this.selectIndex=='teacher'){
    this.$router.push(`/parentReg?identity=${identity}&backUrl=${this.$route.query.backUrl}`);
    }


  }
  },
}


</script>

<style lang="less" scoped>
  * {
    box-sizing: border-box;
  }

  .identity-list {
    text-align: left;
    min-height: 100vh;
    background-color: #fff;
    padding: 35px 30px;

    .title-c {
      font-size: 25px;
      font-weight: normal;
      color: #222200;
      line-height: 35px;
      margin-bottom: 40px;
    }

    .identity-item {
      img {
        width: 100%;
      }
      margin-bottom: 40px;

      &.active {
        img {
          box-shadow: 0px 5px 9px 0px rgba(13, 112, 191, 0.19);
          border-radius: 7px 55px 55px 7px;
          border: 1px solid #1469ff;
        }
      }
    }
  }
</style>
